import {SupportedChainId} from "constants/chains";
import {NATIVE_CHAIN_ID} from "constants/tokens";
import {CHAIN_ID_TO_BACKEND_NAME} from "graphql/data/util";

export enum Chain {
  CRAT = 'CRAT',
  CRAT_TESTNET = 'CRAT_TESTNET',
  UnknownChain = 'UNKNOWN_CHAIN'
}

export const CHAIN_NAME_TO_CHAIN_ID: { [key in Chain]: SupportedChainId } = {
  [Chain.CRAT]: SupportedChainId.CRAT,
  [Chain.CRAT_TESTNET]: SupportedChainId.CRAT_TESTNET,
  [Chain.UnknownChain]: SupportedChainId.CRAT_TESTNET,
}

const URL_CHAIN_PARAM_TO_BACKEND: { [key: string]: Chain } = {
  bsc_mainnet: Chain.CRAT,
  bsc_testnet: Chain.CRAT_TESTNET,
}

export function chainIdToBackendName(chainId: number | undefined) {
  return chainId && CHAIN_ID_TO_BACKEND_NAME[chainId]
    ? CHAIN_ID_TO_BACKEND_NAME[chainId]
    : CHAIN_ID_TO_BACKEND_NAME[SupportedChainId.CRAT_TESTNET]
}

export function validateUrlChainParam(chainName: string | undefined) {
  return chainName && URL_CHAIN_PARAM_TO_BACKEND[chainName] ? URL_CHAIN_PARAM_TO_BACKEND[chainName] : Chain.CRAT_TESTNET
}

export function getTokenDetailsURL({
   address,
   chain,
   inputAddress,
 }: {
  address?: string | null
  chain: Chain
  inputAddress?: string | null
}) {
  const chainName = chain.toLowerCase()
  const tokenAddress = address ?? NATIVE_CHAIN_ID
  const inputAddressSuffix = inputAddress ? `?inputCurrency=${inputAddress}` : ''
  return `/tokens/${chainName}/${tokenAddress}${inputAddressSuffix}`
}
